import React, { Component } from 'react'

export default class CardComponent extends Component {
    render() {
        const { skills, type } = this.props
        return (
            <div className='elite-skill-cards'>
                {
                    type === 'mentor' ?
                        <div className={window.innerWidth > 767 ? 'row row-cols-5 mt-2' : 'row flex-nowrap overflow-auto mt-2'} style={{ marginLeft: window.innerWidth > 767 ? -8 : '' }} >
                            {
                                skills && skills.map((el, i) => {
                                    return (
                                        <div key={i} className={window.innerWidth > 767 ? 'col pr-0 mt-1 mb-2 d-flex align-self-stretch cursor-pointer' : 'card-align padding-less  mt-1 mb-2 d-flex align-self-stretch cursor-pointer'} style={{ marginRight: window.innerWidth > 767 ? -4 : 0 }}>
                                            <div className='card'  >
                                                <div className="card__img">
                                                    <img src='/images/sample.svg' alt="" />
                                                </div>
                                                <div className="card__body pt-2">
                                                    <h1 className='body-text elipsis' title={el.title}>{el.title}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div> :
                        <div className={window.innerWidth > 767 ? 'row row-cols-5 mt-2' : 'row mt-2'} style={{ marginLeft: window.innerWidth > 767 ? -8 : '' }} >
                            {
                                skills && skills.map((el, i) => {
                                    return (
                                        <div key={i} className={window.innerWidth > 767 ? 'col pr-0 mt-1 mb-2 d-flex align-self-stretch cursor-pointer' : 'card-align col-4 padding-less  mt-1 mb-2 d-flex align-self-stretch cursor-pointer'} style={{ marginRight: window.innerWidth > 767 ? -4 : 0 }}>
                                            <div className='card'  >
                                                <div className="card__img">
                                                    <img src={el.image} alt="" />
                                                </div>
                                                <div className="card__body pt-2">
                                                    <h1 className='body-text elipsis' title={el.title}>{el.title}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                }

            </div>
        )
    }
}
